import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/pages/articles/ArticleContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FullArticlePreview"] */ "/app/app/components/pages/articles/FullArticlePreview/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/pages/articles/LimitedArticlePreview/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoBackLink"] */ "/app/app/components/shared/nav/GoBackLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/box/box.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/button/button.js");
;
import(/* webpackMode: "eager", webpackExports: ["Flex"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/flex/flex.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/typography/text.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
